// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Page_wrapper__8PF1j","breadcrumb":"Page_breadcrumb__cHv0P","twoColLayout":"Page_twoColLayout__KNod_","contentCol":"Page_contentCol__b1Ppl","adCol":"Page_adCol__iplnI"};